module.exports = "<div class=\"input-file\">\n\t<label class=\"btn-transparent btn-icon\" for=\"{{ id }}\" *ngIf=\"label\"><span class=\"btn btn-white-primary btn-shadow btn-round\"><i class=\"icon-add\"></i></span>&nbsp;{{label}}</label>\n\t<input \n\t\ttype=\"file\" \n\t\t(change)=\"change($event)\"\n\t\tid=\"{{ id }}\">\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/vqforms/form-file/form-file.component.html
// module id = ./src/app/vqforms/form-file/form-file.component.html
// module chunks = main